import { render } from "./HistoricoList.vue?vue&type=template&id=4819ea77"
import script from "./HistoricoList.vue?vue&type=script&lang=js"
export * from "./HistoricoList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__